import { render, staticRenderFns } from "./SchoolTestInformation.vue?vue&type=template&id=7717982c&scoped=true&lang=pug&"
import script from "./SchoolTestInformation.vue?vue&type=script&lang=ts&"
export * from "./SchoolTestInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolTestInformation.vue?vue&type=style&index=0&id=7717982c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717982c",
  null
  
)

export default component.exports